import {server} from '../Data/BuildEnvironment'
import {HttpRequest} from '../Data/HttpRequest'
import * as PrismaFileType from '../Entities/PrismaFileType'

export function download(id: number): HttpRequest {
    return {
        verb: 'GET',
        url: `${server}/prisma-files/${id}/download`,
        headers: {},
    }
}

export function upload(
    prismaRequestId: number,
    file: File,
    type: PrismaFileType.M
): HttpRequest {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('type', type)
    return {
        verb: 'POST',
        url: `${server}/prisma-requests/${prismaRequestId}/prisma-files`,
        headers: {},
        body: formData,
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/PrismaFileResource.ts